import React from "react";
import json_about from "./About.json";
import Members from "./Members.jsx";
import json_navbar from "../UI/Navbar/Navbar.json";

import "./about.css";

const About = ({ lang }) => {
  return (
    <div className="about">
      <h1>{json_navbar.about[lang]}</h1>
      {json_about[lang].map((paragraph, index) => (
        <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
      ))}
      <Members lang={lang} />
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.jsx